import { CONSULTINGCHECKZIPCODE, CONSULTINGCHECKZIPCODE_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const consultingChCheckZipcode = (body) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.patch(`/api/support/validate-coverage`, body, {
      withApiKey: true,
    });

    const { data, status } = response || {};

    dispatch({
      type: CONSULTINGCHECKZIPCODE,
      payload: data || {},
      status: status || {},
      method: 'patch',
    });
  } catch (e) {
    dispatch({
      type: CONSULTINGCHECKZIPCODE_ERROR,
      payload: e || {},
    });
  }
};
